import { useLayoutEffect, useRef, useState } from "react";

const CHAMFER_X = 13.12;
const CHAMFER_Y = 14.03;
const BORDER_INSET = 0.5;
const CANVAS_BLEED = 1;
const BRACKET_LENGTH = 8;
const BRACKET_INSET = 2;
const BRACKET_STROKE_WIDTH = 1.25;

// Web equivalent of worker's measured ChamferCard outline (bottomOnly).
export const ChamferOutline = ({
  isSelected = false,
}: {
  isSelected?: boolean;
}) => {
  /* React Hooks */
  const outlineRef = useRef<SVGSVGElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const card = outlineRef.current?.parentElement;
    if (!card) return;
    const updateSize = () => {
      const { width, height } = card.getBoundingClientRect();
      setSize((previous) =>
        previous.width === width && previous.height === height
          ? previous
          : { width, height },
      );
    };
    updateSize();
    const observer = new ResizeObserver(updateSize);
    observer.observe(card);
    return () => observer.disconnect();
  }, []);

  /* Render */
  const render = () => {
    const { width, height } = size;
    const inset = BORDER_INSET;
    const bleed = CANVAS_BLEED;
    const path = `M${bleed + inset} ${bleed + inset}H${bleed + width - inset}V${bleed + height - CHAMFER_Y}L${bleed + width - CHAMFER_X} ${bleed + height - inset}H${bleed + inset}Z`;
    const left = bleed + BRACKET_INSET;
    const top = bleed + BRACKET_INSET;
    const right = bleed + width - BRACKET_INSET;
    const bottom = bleed + height - BRACKET_INSET;
    const brackets = `M${left} ${top + BRACKET_LENGTH}V${top}H${left + BRACKET_LENGTH} M${left} ${bottom - BRACKET_LENGTH}V${bottom}H${left + BRACKET_LENGTH} M${right - BRACKET_LENGTH} ${top}H${right}V${top + BRACKET_LENGTH}`;
    return (
      <svg
        ref={outlineRef}
        className="lever-chamfer-outline"
        width={width + bleed * 2}
        height={height + bleed * 2}
      >
        {width > 0 ? (
          <path
            className={isSelected ? "lever-selected-outline" : undefined}
            pathLength={1}
            d={path}
            fill="none"
            stroke={
              isSelected
                ? "rgb(var(--lever-border-action))"
                : "rgb(var(--lever-border-light))"
            }
            strokeWidth={1}
          />
        ) : null}
        {width > 0 && !isSelected ? (
          <path
            d={brackets}
            fill="none"
            stroke="rgb(var(--lever-icon-label) / 0.45)"
            strokeWidth={BRACKET_STROKE_WIDTH}
            strokeLinecap="square"
          />
        ) : null}
      </svg>
    );
  };

  return render();
};
